<template>
    <div class="literacy-assessment-box">
        <div class="header">
            <div class="tab_box">
                <div class="tab_item" :class="'active_tab_item'">
                    素养评价
                </div>
            </div>
            <el-button @click="handleToFeatured">返回</el-button>
        </div>

        <el-scrollbar class="learning_main">
            <el-table
                :data="getTableData"
                style="width: 100%; border-radius: 4px"
                size="medium"
                :header-cell-style="{ fontWeight: 'normal', color: '#333', background: '#f5f7fa' }"
                class="table-content"
                :cell-style="{ fontSize: '12px', color: '#333' }"
            >
                <el-table-column prop="student_name" label="学生名称"> </el-table-column>
                <el-table-column prop="account" label="账号"> </el-table-column>
                <el-table-column prop="evaluation_status" label="评定状态">
                    <template slot-scope="scope">
                        <span :class="`evaluation-status-${scope.row.evaluation_status}`">
                            {{ scope.row.evaluation_status == 0 ? "未评定" : "已评定" }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="address" label="操作" width="80">
                    <template slot-scope="scope">
                        <el-button type="text" @click="evaluation(scope.row.student_id)">评定</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-scrollbar>

        <div class="pagination">
            <el-pagination
                :current-page="pageParams.page"
                :page-size="pageParams.size"
                @current-change="handleCurrentChange"
                background
                layout="prev, pager, next"
                :total="ListData.length"
            >
            </el-pagination>
        </div>
    </div>
</template>

<script>
export default {
    name: "LiteracyAssessment",
    data() {
        return {
            selectClassGradId: "",
            classGradData: [], //班级列表,
            tableData: [],
            ListData: [
                {
                    student_name: "张丽芳",
                    account: "ZLF--",
                    evaluation_status: 0, //0 未评定  1已评定
                    avatar: "",
                    student_id: 1,
                    c_name: "21幼教2",
                    c_id: 488,
                },
                {
                    student_name: "王朋康",
                    account: "Kangker",
                    evaluation_status: 0, //0 未评定  1已评定
                    avatar: "",
                    student_id: 2,
                    c_name: "21幼教2",
                    c_id: 488,
                },
                {
                    student_name: "崔心香",
                    account: "Cuixx8",
                    evaluation_status: 0, //0 未评定  1已评定
                    avatar: "",
                    student_id: 3,
                    c_name: "21幼教2",
                    c_id: 488,
                },
                {
                    student_name: "李听荷",
                    account: "litinghe001",
                    evaluation_status: 0, //0 未评定  1已评定
                    avatar: "",
                    student_id: 4,
                    c_name: "21幼教2",
                    c_id: 488,
                },
                {
                    student_name: "张玲然",
                    account: "ranran08",
                    evaluation_status: 0, //0 未评定  1已评定
                    avatar: "",
                    student_id: 5,
                    c_name: "21幼教2",
                    c_id: 488,
                },
                {
                    student_name: "林宛菡",
                    account: "wanhan166",
                    evaluation_status: 0, //0 未评定  1已评定
                    avatar: "",
                    student_id: 6,
                    c_name: "jisuanji1ban",
                    c_id: 483,
                },
                {
                    student_name: "吴书意",
                    account: "huyiwu",
                    evaluation_status: 0, //0 未评定  1已评定
                    avatar: "",
                    student_id: 7,
                    c_name: "jisuanji1ban",
                    c_id: 483,
                },
                {
                    student_name: "赵歌飞",
                    account: "Gefly1608",
                    evaluation_status: 0, //0 未评定  1已评定
                    avatar: "",
                    student_id: 8,
                    c_name: "jisuanji1ban",
                    c_id: 483,
                },
                {
                    student_name: "周冬灵",
                    account: "winterling",
                    evaluation_status: 0, //0 未评定  1已评定
                    avatar: "",
                    student_id: 9,
                    c_name: "jisuanji1ban",
                    c_id: 483,
                },
                {
                    student_name: "张静",
                    account: "jinger0112",
                    evaluation_status: 0, //0 未评定  1已评定
                    avatar: "",
                    student_id: 10,
                    c_name: "jisuanji1ban",
                    c_id: 483,
                },
            ],
            pageParams: {
                page: 1,
                size: 10,
            },
            total: 0,
        };
    },
    mounted() {
        const evaluationIds = sessionStorage.getItem("evaluationIds");
        if (evaluationIds) {
            const ids = JSON.parse(evaluationIds);

            this.ListData.forEach((item, index) => {
                if (ids.includes(item.student_id.toString())) {
                    this.$set(this.ListData[index], "evaluation_status", 1);
                }
            });
        }
    },
    computed: {
        getTableData() {
            return this.ListData.slice((this.pageParams.page - 1) * this.pageParams.size, this.pageParams.page * this.pageParams.size);
        },
    },
    methods: {
        handleToFeatured() {
            this.$router.push({
                path: "/teachingCenter/teacherFeatured",
                query: {
                    course_id: this.$route.query.course_id,
                },
            });
        },

        // 评定
        evaluation(id) {
            this.$router.push({
                path: "/teachingCenter/evaluationDetail",
                query: {
                    id: id,
                    course_id: this.$route.query.course_id,
                },
            });
        },

        handleCurrentChange(val) {
            this.pageParams.page = val;
        },
    },
};
</script>

<style scoped lang="scss">
.literacy-assessment-box {
    // margin-top: 16px; 
    background-color: #ffffff;
    height: calc(100% - 30px);
    box-sizing: border-box;
    // padding: 28px 28px 30px 36px;
    padding-inline: 28px 36px;
    overflow: hidden;

    .header {
        width: 100%;
        // padding: 0 44px;
        border-bottom: 1px solid #eeeeee;
        display: flex;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #666666;
        line-height: 21px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        display: flex;
        justify-content: space-between;
        box-sizing: border-box;
        .tab_box {
            display: flex;
            .tab_item {
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                font-size: 18px;
                color: #f23b2f;
                line-height: 21px;
                padding-bottom: 21px;
                text-align: center;
                font-style: normal;
                text-transform: none;
            }
            .active_tab_item {
                color: #f23b2f;
                border-bottom: 3px solid #f23b2f;
            }
        }

        .el-button {
            width: 96px;
            height: 38px;
            font-size: 16px;
            color: #606266;
        }
    }

    .learning_main {
        width: 100%;
        height: calc(100% - 46px - 60px);
        // padding-bottom: 30px;
        box-sizing: border-box;
        margin-top: 20px;
        background-color: #ffffff;

        ::v-deep .el-scrollbar__wrap {
            overflow-x: hidden;
        }

        .el-table {
            &::before {
                display: none;
            }

            ::v-deep .el-button {
                color: #006eff;
            }

            ::v-deep .cell {
                color: #3e3e3e;
                font-size: 14px;

                span.evaluation-status-0 {
                    color: #ff2626;
                }
            }
        }
    }

    .pagination {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 50px;
    }

    ::v-deep .el-input__inner {
        background: #fff !important;
    }
    ::v-deep .el-select .el-input.is-focus .el-input__inner {
        border-color: #409eff !important;
    }
}
</style>
